// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wKvg","comment":"styles_comment__2i_oe"};